import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';

import { ApiError, MessageService } from '../../../core';
import { unidadeNegocioAtiva, unidadeNegocioInativa } from '../unidade-negocio-situacao';
import { UnidadeNegocioFilter } from '../filter';
import { UnidadeNegocioCrudHttpService } from '../services';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-unidade-negocio-multiselect',
    templateUrl: './unidade-negocio-multiselect.component.html',
    styleUrls: ['./unidade-negocio-multiselect.component.less']
})
export class UnidadeNegocioMultiselectComponent implements OnInit {
    /** Unidades de negócios selecionadas */
    @Input() idsUnidadesNegocios: number[];
    /** Ao alterar a seleção das unidades de negócios */
    @Output() idsUnidadesNegociosChange = new EventEmitter<number[]>();

    /** Se deve exibir as unidades de negócios ativas */
    @Input() ativas = true;
    /** Se deve exibir as unidades de negócios inativas */
    @Input() inativas = false;
    /** Se deve exibir considerar as linhas de produções ativias das unidades de negócios */
    @Input() linhasProducoesAtivas = true;
    /** Se deve exibir considerar as linhas de produções inativas das unidades de negócios */
    @Input() linhasProducoesInativas = false;

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() checked = 'Unidade de Negócio';
    @Input() defaultTitle = 'Nenhuma Unidade de Negócio';
    @Input() checkedPlural = 'Unidades de Negócios';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas'
    @Input() searchEmptyResult = 'Nenhuma unidade de negócio encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private messageService: MessageService,
                private unidadeNegocioCrudHttpService: UnidadeNegocioCrudHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-unidade-negocio ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Obtem as situações das unidades de negócios conforme as opções desejadas */
    private getSituacoes(): number[] {
        const situacoes: number[] = [];
        // Ativas
        if (this.ativas) {
            situacoes.push(unidadeNegocioAtiva.id);
        }
        // Inativas
        if (this.inativas) {
            situacoes.push(unidadeNegocioInativa.id);
        }

        return situacoes;
    }

    /** Cria as unidades de negócios para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter = new UnidadeNegocioFilter();
        filter.situacoes = this.getSituacoes();
        this.unidadeNegocioCrudHttpService.searchWithFilter(filter)
            .pipe(
                take(1)
            )
            .subscribe(
                entities => {
                    if (entities) {
                        entities.forEach(entity => {
                            selects.push({
                                id: entity.id,
                                name: entity.nome
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message, 'Erro ao pesquisar as unidades de negócios', error);
                }
            );
    }

    /** Ao alterar a seleção das unidades de negócios */
    onChange() {
        this.idsUnidadesNegociosChange.emit(this.idsUnidadesNegocios);
    }
}
